import React from 'react';
import { BrowserRouter as Router, Navigate, Outlet, Route, Routes } from 'react-router-dom';
import './App.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import Navbar from './components/Navbar';
import { Home } from './pages/Home';
import {Reporte} from './pages/Reporte';

import Medicion from './pages/Medicion';
import Seguimiento from './pages/Seguimiento';
import { Alcance1 } from './pages/Alcance1';


import Login from './Login';
import Register from './Register';
import Reset from './Reset';
/*import Dashboard from './Dashboard';
import Loading from './Loading';*/
import { Categorias } from './Categorias';
import { Subcategoria } from './Subcategoria';
import { auth } from './firebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import { Entradas } from './Entradas';
import { Compensacion } from './pages/Compensacion';
import { Contacto } from './components/Contacto';
import { Reduccion } from './pages/Reduccion';
import { MedirReduccion } from './components/MedirReduccion';

function App( ) {
  const [user] = useAuthState(auth);

  const ProtectedRoute = ({ user, redirectPath= '/' }) => {
    if (!user) {
      return <Navigate to={redirectPath} replace />;
    }
    return <Outlet />;
  }

  return (
    /*<UserProvider>*/
      <Router>
        <Routes>
          <Route exact path='/' element={<Login />} />
          
            <Route element={(
              <>
                <Navbar />
                <Outlet />
              </>
            )}>
              <Route element={ <ProtectedRoute user={user} />}>
                <Route path="/home" element={<Home user={user}/> } />
                <Route path="/medicion" element={<Home user={user}/>}/>
                <Route path="/alcance1" element={<Alcance1 user={user}/>}/>
              
                <Route exact path='/seguimiento' element={<Seguimiento user={user} />} />
                <Route exact path='/compensacion' element={<Compensacion user={user} />} />
                <Route exact path='/reduccion' element={<Reduccion user={user} />} />
                <Route exact path='/medirreduccion' element={<MedirReduccion user={user} />} />
                <Route exact path='/reporte' element={<Reporte user={user} />} />
                
                <Route exact path='/categorias' element={<Categorias user={user}/>} />
                <Route path="/entradas" element={<Entradas user={user}/>}/>

                <Route exact path='/contacto' element={<Contacto user={user}></Contacto>} />
                <Route exact path='/subcategoria' element={<Subcategoria user={user}/>} />
              </Route>
            </Route>

            <Route exact path='/register' element={<Register />} />
            <Route exact path='/reset' element={<Reset />} />
        </Routes>
      </Router>
    /*</UserProvider>*/
  );
}

export default App;
          